import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  schema?: object | object[];
  ogType?: string;
  ogImage?: string;
  noIndex?: boolean;
  ogArticle?: {
    publishedTime?: string;
    author?: string;
    section?: string;
    tags?: string[];
  };
}

export function SEOHead({ title, description, canonical, schema, ogType, ogImage, noIndex, ogArticle }: SEOHeadProps) {
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];
  const resolvedOgImage = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `https://kimfloraldesigns.com${ogImage.startsWith("/") ? "" : "/"}${ogImage}`
    : "https://kimfloraldesigns.com/og-image.png";

  return (
    <Helmet>
      <title>{title}</title>
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogType && <meta property="og:type" content={ogType} />}
      <meta property="og:image" content={resolvedOgImage} />
      {canonical && <meta property="og:url" content={canonical} />}
      {ogArticle?.publishedTime && <meta property="article:published_time" content={ogArticle.publishedTime} />}
      {ogArticle?.author && <meta property="article:author" content={ogArticle.author} />}
      {ogArticle?.section && <meta property="article:section" content={ogArticle.section} />}
      {ogArticle?.tags?.map((tag) => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={resolvedOgImage} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
